import { FormattedMessage } from 'react-intl';
import { FormGroup } from '../../../../../../Components/FormGroup/FormGroup';

function PriorityBar({
  id,
  titleId,
  defaultValue,
  provincePriority,
  handleChange,
  state,
  register,
  error
}) {
  return (
    <div className="row  mb-2">
      <div className="col-md-2 input-group-prepend">
        <span className="input-group-text justify-content-center">
          <FormattedMessage id={titleId} />
        </span>
      </div>
      <div className="col-md-3">
        <FormattedMessage id="please_select">
          {(placeholder) => (
            <FormGroup
              id={id}
              type="select"
              placeholder={placeholder[0]}
              options={provincePriority}
              onChange={handleChange}
              required={true}
              errorId={`prioirty`}
              defaultValue={(state && state[id]) || (defaultValue && defaultValue[id])}
              register={register}
              error={error}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
}

export default PriorityBar;
